import { render, staticRenderFns } from "./vImportBulkCostsModal.vue?vue&type=template&id=0b3ed7e6"
import script from "./vImportBulkCostsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./vImportBulkCostsModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports